import { ActivityStoreType } from '@/types/store/activity-store.type';

export const state: ActivityStoreType = {
  activity: null
};
